import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClipboardCheck, HardHat, ShieldAlert, ShieldCheck, Users, BarChart3, CheckCircle2, ArrowRight } from 'lucide-react';
import { services } from '../mock';
import SectionLabel from '../components/SectionLabel';
import Reveal from '../components/Reveal';

const iconMap = { ClipboardCheck, HardHat, ShieldAlert, ShieldCheck, Users, BarChart3 };

const Services = () => {
  return (
    <div className="relative">
      <section className="pt-20 pb-10 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-40" />
        <div className="relative max-w-[1320px] mx-auto px-6">
          <SectionLabel>SERVICES / ADVISORY SCOPES</SectionLabel>
          <h1 className="mt-4 font-serif text-white text-5xl md:text-6xl leading-[1.05] tracking-tight max-w-4xl">
            Six specialised scopes covering the full lifecycle of road asset governance.
          </h1>
          <p className="mt-5 max-w-2xl text-slate-400 text-lg leading-relaxed">
            Each engagement is senior-led, evidence-backed, and delivered under transparent scoping. Explore individual service scopes and typical deliverables below.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-[1320px] mx-auto px-6 space-y-6">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || ClipboardCheck;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }} transition={{ duration: 0.6 }}
                className="rounded-xl border border-white/8 bg-[#0f1a2f]/50 p-6 md:p-8 hover-ring transition-all"
              >
                <div className="grid md:grid-cols-12 gap-6 items-start">
                  <div className="md:col-span-1">
                    <div className="font-serif text-5xl text-orange-400/80">{s.id}</div>
                  </div>
                  <div className="md:col-span-7">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-md bg-white/5 border border-white/10 flex items-center justify-center text-orange-400"><Icon className="w-5 h-5" /></div>
                      <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-orange-300 px-2 py-1 rounded bg-orange-500/10 border border-orange-500/20">{s.category}</span>
                    </div>
                    <h2 className="mt-4 font-serif text-white text-2xl md:text-3xl leading-snug">{s.title}</h2>
                    <p className="mt-3 text-slate-400 leading-relaxed">{s.description}</p>
                  </div>
                  <div className="md:col-span-4">
                    <div className="text-[11px] font-mono tracking-[0.2em] text-slate-500 mb-3">TYPICAL DELIVERABLES</div>
                    <ul className="space-y-2">
                      {s.deliverables.map((d) => (
                        <li key={d} className="flex items-start gap-2 text-sm text-slate-200">
                          <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                          {d}
                        </li>
                      ))}
                    </ul>
                    <div className="mt-5 flex items-center justify-between pt-4 border-t border-white/5">
                      <Link to="/contact" className="inline-flex items-center gap-1.5 text-sm text-orange-300 hover:text-orange-200 font-medium">
                        Discuss this scope <ArrowRight className="w-3.5 h-3.5" />
                      </Link>
                      <span className="text-[10px] font-mono text-slate-500">Ref: {s.ref}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Services;
